import { ThemeDetails } from '@yandex-int/k-common/typings';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';

import { getTeamGrade } from 'common.components/user/selectors';

import { ReduxTeacherStore } from '../../typings';
import * as libraryActions from '../library.store/actions';
import { getThemeDetails } from '../library.store/selectors';

import Content from './__content/section-page__content';

interface StoreProps {
    teamGrade: number | null;
    themeDetails: ThemeDetails | null;
}

interface DispatchProps {
    getThemeInfoRequest: typeof libraryActions.getThemeDetailsRequest;
    getThemeDetailsSuccess: typeof libraryActions.getThemeDetailsSuccess;
}

interface HOCProps extends WithRouterPathProps {}

interface Props extends HOCProps, StoreProps, DispatchProps {}

interface Context {
    data: {
        getThemeDetails?: ThemeDetails;
    };
    initialRender: boolean;
}

export class SectionPage extends React.Component<Props> {
    static contextTypes = {
        data: PropTypes.object,
        initialRender: PropTypes.bool.isRequired,
    };

    constructor(props: Props, context: Context) {
        super(props, context);

        const {
            getThemeInfoRequest,
            match: {
                params: { themeId },
            },
            getThemeDetailsSuccess,
            themeDetails,
        } = props;
        const { initialRender, data } = context;

        if (initialRender && data.getThemeDetails) {
            getThemeDetailsSuccess(Number(themeId), data.getThemeDetails);
        } else if (themeId && !themeDetails) {
            getThemeInfoRequest(Number(themeId));
        }
    }

    componentDidUpdate(prevProps: Props) {
        const {
            match: {
                params: { themeId: prevThemeId },
            },
        } = prevProps;
        const {
            getThemeInfoRequest,
            teamGrade,
            match: {
                params: { themeId },
            },
        } = this.props;

        if (prevThemeId !== themeId || teamGrade !== prevProps.teamGrade) {
            getThemeInfoRequest(Number(themeId));
        }
    }

    render() {
        return <Content />;
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, { match: { params } }: HOCProps): StoreProps => {
    const classId = Number(params.classId);
    const themeId = Number(params.themeId);

    return {
        teamGrade: getTeamGrade(storeState, { classId }),
        themeDetails: getThemeDetails(storeState, { themeId }),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return bindActionCreators(
        {
            getThemeInfoRequest: libraryActions.getThemeDetailsRequest,
            getThemeDetailsSuccess: libraryActions.getThemeDetailsSuccess,
        },
        dispatch
    );
};

export default withRouterPath(connect(mapStateToProps, mapDispatchToProps)(SectionPage));
